import React from 'react';
import ReactDOM from 'react-dom';
import reportWebVitals from './reportWebVitals';
import App from './App';
const APP_ROOT_ID = 'root';
const appRoot = document.getElementById(APP_ROOT_ID);

if (appRoot) {
  window.reactAppRoot = appRoot; 
}

setupDevelopmentTools();
renderApplication();

export function getLang() {
  const attrList = document.documentElement.getAttributeNames();
  const langAttr =
    attrList.filter((attr) => attr.endsWith('selected-lang'))[0] || 'lang';
  return (document.documentElement.getAttribute(langAttr) || 'fi')
    .substring(0, 2)
    .toLowerCase();
}

function renderApplication() {
  if (appRoot) {
    ReactDOM.render(
      <React.StrictMode>
        <App locale={getLang()} />
      </React.StrictMode>,
      appRoot
    );
  }
}

/* istanbul ignore next */
function setupDevelopmentTools() {
    // Wrap development block with dev mode check - terser gets rid of this block during production build
    if (process.env.NODE_ENV === 'development') {
        import('@op/luna.local-development-environment/setup').then(({ setup }) =>
            setup({ APP_ROOT_ID: 'root', renderApplication })
        );
    }
}

// // If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();